<script lang="ts" setup>
const { t: $t } = useI18n()

import type { MachineryRubrics } from '~/types'
import type { ApiMachineryPublicBaseSelect } from '~/layers/customer-module/types'

defineProps<{ machinery?: ApiMachineryPublicBaseSelect | null, isLoading?: boolean }>()

const { foreignMachineryCreationFieldsByRubric } = useFormOptionalConditions()

const machineryPublicVehicleData = computed((): OneDataColumn<ApiMachineryPublicBaseSelect>[] => [
  {
    title: $t('customerModule.machinery.details.machinery.vehicleDataColumn.producer'),
    key: 'producerCompanyName',
  },
  {
    title: $t('customerModule.machinery.details.machinery.vehicleDataColumn.rubric'),
    key: 'machineryRubric',
    render: ({ machineryRubric }) => $t(`machinery.rubric.${machineryRubric}`),
  },
  {
    title: $t('customerModule.machinery.details.machinery.vehicleDataColumn.liftingWeight'),
    key: 'receptionMachinery',
    render: ({ receptionMachinery }) => receptionMachinery?.liftingWeight,
    isVisible: ({ machineryRubric }) => foreignMachineryCreationFieldsByRubric.liftingWeight.includes(machineryRubric as MachineryRubrics),
  },
  {
    title: $t('receptionMachinery.field.tractionForce.name'),
    key: 'receptionMachinery',
    render: ({ receptionMachinery }) => receptionMachinery?.tractionForce,
    isVisible: ({ machineryRubric }) => foreignMachineryCreationFieldsByRubric.tractionForce.includes(machineryRubric as MachineryRubrics),
  },
  {
    title: $t('receptionMachinery.field.basketLoad.name'),
    key: 'receptionMachinery',
    render: ({ receptionMachinery }) => receptionMachinery?.basketLoad,
    isVisible: ({ machineryRubric }) => foreignMachineryCreationFieldsByRubric.basketLoad.includes(machineryRubric as MachineryRubrics),
  },
  {
    title: $t('customerModule.machinery.details.machinery.vehicleDataColumn.type'),
    key: 'receptionMachinery',
    render: ({ receptionMachinery }) => receptionMachinery?.type?.name,
  },
  {
    title: $t('customerModule.machinery.details.machinery.vehicleDataColumn.yearBuilt'),
    key: 'receptionMachinery',
    render: ({ receptionMachinery }) => receptionMachinery?.yearBuilt,
  },
  {
    title: $t('customerModule.machinery.details.machinery.vehicleDataColumn.product'),
    key: 'receptionMachinery',
    render: ({ receptionMachinery }) => receptionMachinery?.product,
  },
  {
    title: $t('customerModule.machinery.details.machinery.vehicleDataColumn.drive'),
    key: 'receptionMachinery',
    render: ({ receptionMachinery }) => receptionMachinery?.drive ? $t(`machinery.drive.${receptionMachinery.drive.name}`) : undefined,
    isVisible: ({ machineryRubric }) => foreignMachineryCreationFieldsByRubric.drive.includes(machineryRubric as MachineryRubrics),
  },
  {
    title: $t('customerModule.machinery.details.machinery.vehicleDataColumn.weight'),
    key: 'receptionMachinery',
    render: ({ receptionMachinery }) => receptionMachinery?.weight?.toLocaleString('de-DE'),
  },
  {
    title: $t('customerModule.machinery.details.machinery.vehicleDataColumn.operatingHours'),
    key: 'receptionMachinery',
    render: ({ isForeignMachinery, receptionMachinery }) => {
      if (!receptionMachinery?.operatingHours) {
        return undefined
      }
      return isForeignMachinery ? receptionMachinery.operatingHours.toLocaleString('de-DE') : (receptionMachinery.operatingHours + 50).toLocaleString('de-DE')
    },
  },
])
</script>

<template>
  <CustomerModuleDataCard :title="$t('customerModule.machinery.details.machinery.vehicleData')" :is-loading="isLoading">
    <template #headerExtra>
      <slot name="headerExtra" />
    </template>
    <TableOneDataColumn :config="{ data: machinery, columns: machineryPublicVehicleData }" class="text-base" />
  </CustomerModuleDataCard>
</template>
